// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".donation-options-info__title{font-size:24px;font-weight:600}.donation-options-info__description{font-size:16px;line-height:22px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
